// extracted by mini-css-extract-plugin
export default {"dialog":"DialogPreview_dialog__2bbsW","title":"DialogPreview_title__06aFi","video":"DialogPreview_video__HZFJ0","settings":"DialogPreview_settings__b4wK+"};